import { DateLabel } from '#utils/datelabel'
import { SlotCardProps } from '#vessel/overview'
import { utils } from 'apprise-core/utils'
import { useT } from 'apprise-frontend-core/intl/language'
import { TenantLabel } from 'apprise-frontend-iam/tenant/label'
import { useTenantUtils } from 'apprise-frontend-iam/tenant/utils'
import { TagLabel } from 'apprise-frontend-tags/tag/label'
import { classname } from 'apprise-ui/component/model'
import { Grid } from 'apprise-ui/grid/grid'
import { NamedProperty } from 'apprise-ui/utils/namedproperty'
import isAfter from 'date-fns/isAfter'
import { Fragment } from 'react'
import { TrxAuthPatch } from './model'

export const TrxAuthzOverview = (props: SlotCardProps<TrxAuthPatch>) => {

    const t = useT()

    const { showChange, isCurrent, record, previous } = props

    const tenants = useTenantUtils()


    const authzs = record.trxauthz.authzs
    const grantedBy = Object.keys(authzs).sort(tenants.refComparator)

    const previousAuthzs = showChange && previous?.trxauthz?.authzs
    
    const previousKeys = previousAuthzs 
        ? new Set(Object.entries(previousAuthzs).flatMap(([tid, authzList]) => 
            authzList.map(a => `${tid}-${a.timestamp}-${a.type}-${a.from}-${a.to}`)
        ))
        : undefined

    const now = Date.now()
    
    return <Grid rowGap={8} columnGap={10} >


        <Grid.Row>

            <Grid.Col width={130}>
                <NamedProperty className='trxauthz-header' name={t('trxauthz.reportedon_col')} />
            </Grid.Col>
            <Grid.Col width='2fr'>
                <NamedProperty className='trxauthz-header' name={t('trxauthz.tenant_col')} />
            </Grid.Col>
            <Grid.Col width={120}>
                <NamedProperty className='trxauthz-header' name={t('trxauthz.type_col')} />
            </Grid.Col>
            <Grid.Col width={130}>
                <NamedProperty className='trxauthz-header' name={t('trxauthz.from_col')} />
            </Grid.Col>
            <Grid.Col width={130}>
                <NamedProperty className='trxauthz-header' name={t('trxauthz.to_col')} />
            </Grid.Col>

        </Grid.Row>

        {grantedBy.map(tid => {

            // expired authorisations stay in the slot until the vessel's next CV TRX submission prunes them,
            // so the current version shows them too, greyed out by trxauthz-expired.
            const authz = [...authzs[tid]].sort(utils().compareDatesOf( a=> a.timestamp)).reverse()

            return <Fragment key={tid}>
                
                {authz.map( (authz,i) =>{

                    const key = `${tid}-${authz.timestamp}-${authz.type}-${authz.from}-${authz.to}`
                    const isNew = previousKeys ? !previousKeys.has(key) : false
                    const classes = classname( showChange && isNew && 'trxauthz-latest', isAfter(now, Date.parse(authz.to)) && 'trxauthz-expired')

                    return <Grid.Row key={i} height='auto' className={classes} >
                        <Grid.Col width={130}>
                            <NamedProperty valueAlign='right' >
                                <DateLabel titleStyle={{color:'gray'}} noIcon  date={authz.timestamp} />
                            </NamedProperty>
                        </Grid.Col>
                        <Grid.Col width='2fr'>
                            <NamedProperty>
                                <TenantLabel tip={tenants.nameOf(tid)} bare noIcon tenant={tid} />
                            </NamedProperty>
                        </Grid.Col>
                        <Grid.Col width={120}>
                            <NamedProperty>
                                <TagLabel unknown bare noIcon tag={authz.type} />
                            </NamedProperty>
                        </Grid.Col>
                        <Grid.Col width={130}>
                            <NamedProperty>
                                <DateLabel noIcon date={authz.from} />
                            </NamedProperty>
                        </Grid.Col>
                        <Grid.Col width={130} >
                            <NamedProperty>
                                <DateLabel displayMode={isCurrent ? 'expiry' : 'normal'} noIcon date={authz.to} />
                            </NamedProperty>
                        </Grid.Col>
                    </Grid.Row>
            })}

            </Fragment>
        })}
    </Grid>
}
